import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://api.aweioio.com/api/menu-items";
const BASE_URL_POST = "https://api.aweioio.com/api/menu-items-write";
const BASE_URL_GET = "https://api.aweioio.com/api/menu-items-get";


const initialState = {
  menuItems: [],
  loading: false,
  error: null,
};
// slices/MenuItemsSlice.js
export const updateMenuItemImage = createAsyncThunk(
  "menuItems/updateMenuItemImage",
  async ({ itemId, file }, { rejectWithValue }) => {
    console.log(file,"imagefile bobb")
    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await axios.put(`${BASE_URL}/${itemId}/image`, formData);

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


// Fetch all menu items
export const fetchMenuItems = createAsyncThunk(
  "menuItems/fetchMenuItems",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(BASE_URL_GET);
            return res.data; // make sure this is an array on the backend
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create a new menu item
export const createMenuItem = createAsyncThunk(
  "menuItems/createMenuItem",
  async (menuItemData, { rejectWithValue }) => {
    console.log(menuItemData, "menuitmedata"
    )
    try {
      const res = await axios.post(BASE_URL_POST, menuItemData); // Let Axios set headers
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


// Update a menu item
export const updateMenuItem = createAsyncThunk(
  "menuItems/updateMenuItem",
  async ({ itemId, updatedData }, { rejectWithValue }) => {
    console.log(itemId, "itemID UPATE")
    console.log(updatedData, "updatedData UPATE")

    try {
      const res = await axios.put(`${BASE_URL}/${itemId}`, updatedData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


// Delete a menu item
export const deleteMenuItem = createAsyncThunk(
  "menuItems/deleteMenuItem",
  async (itemId, { rejectWithValue }) => {
    try {
      console.log("🔥 Deleting from backend with ID:", itemId); // Log from the thunk
      await axios.delete(`${BASE_URL}/${itemId}`);
      return itemId;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


const menuItemsSlice = createSlice({
  name: "menuItems",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchMenuItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMenuItems.fulfilled, (state, action) => {
        state.loading = false;
        state.menuItems = Array.isArray(action.payload)
          ? action.payload
          : action.payload?.menuItems || [];
      })
      .addCase(fetchMenuItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create
      .addCase(createMenuItem.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createMenuItem.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.menuItems)) {
          state.menuItems.push(action.payload);
        } else {
          state.menuItems = [action.payload];
        }
      })
      .addCase(createMenuItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update
      .addCase(updateMenuItem.fulfilled, (state, action) => {
        const index = state.menuItems.findIndex(i => i._id === action.payload._id);
        if (index !== -1) {
          state.menuItems[index] = action.payload;
        }
      })

      // Delete
      .addCase(deleteMenuItem.fulfilled, (state, action) => {
        state.menuItems = state.menuItems.filter(i => i._id !== action.payload);
      }).addCase(updateMenuItemImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMenuItemImage.fulfilled, (state, action) => {
        state.loading = false;
        // optionally update the item image if needed
      })
      .addCase(updateMenuItemImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Image update failed";
      });
  },
});

export default menuItemsSlice.reducer;
